/**
 * Listing mode helpers — eladó vs HorseFace (mirror of PHP Listing_Mode).
 *
 * UI: listingMode ('elado' | 'horseface')
 * Data: listingType / htipus / _listing_type
 *
 * @package Lovasok_Marketplace
 */

export const TYPE_HORSEFACE = 'horseface';
export const TYPE_ELADO = 'elado';

export function normalizeType(type) {
    return String(type || '').toLowerCase().trim();
}

export function isHorseface(typeOrMode) {
    return normalizeType(typeOrMode) === TYPE_HORSEFACE;
}

export function isMarketplaceListing(typeOrMode) {
    return !isHorseface(typeOrMode);
}

export function requiresPaymentBeforePublish(typeOrMode) {
    return isHorseface(typeOrMode);
}

export function uiMode(typeOrMode) {
    return isHorseface(typeOrMode) ? TYPE_HORSEFACE : TYPE_ELADO;
}

export function labelForType(typeOrMode) {
    return isHorseface(typeOrMode) ? 'HorseFace profil' : 'Hirdetés';
}

/**
 * Success modal copy after instant publish (free marketplace listing).
 *
 * @param {string} typeOrMode
 * @param {{ title?: string }|null} horse
 * @returns {{ title: string, body: string, viewLabel: string }}
 */
export function successCopy(typeOrMode, horse = null) {
    const titleText = horse?.title ? String(horse.title) : '';
    if (isHorseface(typeOrMode)) {
        return {
            title: 'Sikeresen létrehoztad a lóprofilt!',
            body: titleText
                ? `„${titleText}” mostantól a HorseFace profilok között elérhető.`
                : 'A lóprofilod mostantól a HorseFace profilok között elérhető.',
            viewLabel: 'Megnézem a profilt',
        };
    }
    return {
        title: 'Sikeresen feladtad a hirdetést!',
        body: titleText
            ? `„${titleText}” mostantól a Hirdetéseim között elérhető.`
            : 'A hirdetésed mostantól a Hirdetéseim között elérhető.',
        viewLabel: 'Megnézem a hirdetést',
    };
}
